const mutations = {
    SET_ERROR_CUSTOMERS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
